/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { chatSession } from "$lib/stores/chatSessionStore"
import { floraVerseSession } from "$lib/stores/floraVerseStore"
import { datadogLogs } from "@datadog/browser-logs"
import { get } from "svelte/store"

export function floraChatEventTracking(convId: string, action: string, label: string) {
    const trackingEnabled = get(chatSession).flags?.['conversational-tealium-tracking-enabled']
    if (!trackingEnabled) return
    if (typeof window !== 'undefined' && window?.parent) {
        window.parent.postMessage({
            type: 'flora-chat-trigger-event-tracking',
            tracking_data: {
                eventName: 'feature_interaction',
                eventCategory: 'florachat',
                eventAction: action,
                eventLabel: label
            }
        }, '*')
        datadogLogs.logger.info(
            `[Conv-ui] Flora Chat Event Tracking - conversation_id: ${convId} action: ${action} label: ${label}`
        )
    }
}

export function floraVerseEventTracking(convId: string, action: string, label: string, browser_uuid: string) {
    const trackingEnabled = get(floraVerseSession).flags?.['conversational-tealium-tracking-enabled']
    if (!trackingEnabled) return
    if (typeof window !== 'undefined' && window?.parent) {
        window.parent.postMessage({
            type: 'flora-verse-trigger-event-tracking',
            tracking_data: {
                eventName: 'feature_interaction',
                eventCategory: 'floraverse',
                eventAction: action,
                eventLabel: label,
                ...(browser_uuid ? { browser_uuid } : {})
            }
        }, '*')
        datadogLogs.logger.info(
            `[Conv-ui] Flora Verse Event Tracking - conversation_id: ${convId} action: ${action} label: ${label}`
        )
    }
}
export function floraVersePageTracking(convId: string, pathName: string, pageName: string) {
    const trackingEnabled = get(floraVerseSession).flags?.['conversational-tealium-tracking-enabled']
    if (!trackingEnabled) return
    if (typeof window !== 'undefined' && window?.parent) {
        window.parent.postMessage({
            type: 'flora-verse-trigger-page-tracking',
            page_data: {
                pathName,
                pageName
            }
        }, '*')
        datadogLogs.logger.info(
            `[Conv-ui] Flora Verse Page Tracking - conversation_id: ${convId} path_name: ${pathName} page_name: ${pageName}`
        )
    }
}